import { viperApi, clinicalApiPath } from '@/services/viper-api'

export const userService = {
  basePath: organizationId => `${clinicalApiPath}/organizations/${organizationId}/users`,

  create(organizationId, user) {
    return viperApi.post(this.basePath(organizationId), user)
  },

  list(organizationId) {
    return viperApi.get(this.basePath(organizationId))
  },

  email(organizationId, username) {
    return viperApi.put(`${this.basePath(organizationId)}/${username}/send-invite`)
  }
}
